export enum EventType {
  CPL_OPT_IN = "cpl_opt-in",
}

export enum CplEventAction {
  CLICK_YES = "Click Yes",
  CLICK_NO = "Click NO",
  IMPRESSION = "Impression",
}
